import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import { classesEventStore } from 'state/classes/classesStore'
import FaqModal from 'pages/Events/Views/Common/Modals/FaqModal'
import { EventResp } from 'types/event/events'

const FAQ: React.FC = () => {
  const [faqModalOpen, setFaqModalOpen] = useState<boolean>(false)
  const {
    classesData,
    selectedFaqIds,
    setSelectedFaqIds,
  }: {
    classesData: EventResp
    selectedFaqIds: string[]
    setSelectedFaqIds: (state: string[]) => void
  } = classesEventStore(store => ({
    classesData: store.classesData,
    selectedFaqIds: store.selectedFaqIds,
    setSelectedFaqIds: store.setSelectedFaqIds,
  }))

  return (
    <>
      <div onClick={() => setFaqModalOpen(true)}>
        <IconsTextNavigation
          iconName="Question"
          heading="FAQ"
          isCompleted={selectedFaqIds.length > 0 ? true : false}
        />
      </div>
      {faqModalOpen && (
        <FaqModal
          openModal={faqModalOpen}
          setOpenModal={setFaqModalOpen}
          organizationId={classesData?.organizationId}
          referenceId={classesData?._id}
          reference="class"
          selectedFaqs={selectedFaqIds}
          setSelectedFaqs={setSelectedFaqIds}
        />
      )}
    </>
  )
}

export default FAQ
